/* Most między sklepem a Brevo.
   Klucz trackera (client key) jest z założenia jawny — siedzi w kodzie strony.
   Klucza API (prywatnego) tu nie ma i być nie może: nim tworzy się kontakty
   po stronie serwera, a wszystko w tym pliku wykonuje się w przeglądarce.

   Zapis na listę idzie przez formularz Shopify (klient trafia do Shopify,
   a wtyczka Brevo go synchronizuje) albo przez tracker Brevo, jeśli chcemy
   od razu atrybuty. Zdarzenia wysyłamy trackerem — one wyzwalają automatyzacje. */
(function () {
  var cfg = window.lezeBrevo || {};
  if (!cfg.key) return;
  if (window.lezeBrevoReady) return;
  window.lezeBrevoReady = true;

  window.Brevo = window.Brevo || [];
  window.Brevo.push(['init', { client_key: cfg.key }]);

  if (!document.querySelector('script[src*="brevo.com/js/sdk-loader.js"]')) {
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://cdn.brevo.com/js/sdk-loader.js';
    document.head.appendChild(s);
  }

  /* Kontakt + atrybuty. Brevo używa ich w szablonie jako {{ contact.NAZWA }}. */
  function identify(email, attributes) {
    window.Brevo.push(['identify', {
      identifiers: { email_id: email },
      attributes: attributes || {}
    }]);
  }

  /* Zdarzenie — wyzwalacz automatyzacji. */
  function track(name, email, props) {
    var payload = { data: props || {} };
    if (email) payload.identifiers = { email_id: email };
    window.Brevo.push(['track', name, payload.identifiers || {}, { data: payload.data }]);
  }

  window.lezeBrevo.identify = identify;
  window.lezeBrevo.track = track;

  function status(form, text, isError) {
    var el = form.querySelector('[data-leze-brevo-status]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'leze-form-status';
      el.setAttribute('data-leze-brevo-status', '');
      form.appendChild(el);
    }
    el.textContent = text;
    el.classList.toggle('is-error', !!isError);
  }

  /* Formularze zapisu zostają na Shopify — dzięki temu zgoda i wypis mają jedno
     miejsce, a wtyczka Brevo dociąga kontakt. Tutaj tylko dokładamy atrybuty
     i zdarzenie, żeby automatyzacja wiedziała, skąd przyszedł zapis. */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-leze-brevo-form]');
    if (!form) return;
    var field = form.querySelector('input[type="email"]');
    if (!field || !field.value) return;

    var source = form.getAttribute('data-leze-brevo-form') || 'sklep';
    var attrs = { ZRODLO_ZAPISU: source };
    var ctx = form.querySelector('[data-leze-signup-context]');
    if (ctx && ctx.value) attrs.KONTEKST_ZAPISU = ctx.value;

    identify(field.value, attrs);
    track('zapis_na_liste', field.value, { zrodlo: source });
  });

  /* Quiz: wynik odkładamy, dopisujemy do kontaktu dopiero razem z adresem. */
  /* ── Odstąpienie od umowy: potwierdzenie na trwałym nośniku ──────────────
     Art. 11a każe niezwłocznie potwierdzić konsumentowi wpływ oświadczenia,
     podając jego treść oraz datę złożenia i otrzymania. Formularz kontaktowy
     Shopify wysyła maila do NAS, a klientowi nie odpisuje nic — więc bez tego
     regulamin obiecywałby coś, czego sklep nie robi.

     Zdarzenie idzie po przeładowaniu, nie w chwili wysyłki: formularz Shopify
     robi pełny POST z przekierowaniem, a zdarzenie wystrzelone w locie potrafi
     nie dolecieć. Dlatego treść oświadczenia ląduje w sessionStorage, a wysyłamy
     ją dopiero wtedy, gdy Shopify potwierdzi przyjęcie formularza. Jeden strzał,
     bez ryzyka podwójnego maila.

     Automatyzacja po stronie Brevo: zdarzenie `odstapienie_od_umowy`
     -> wiadomość „LEZE 05 potwierdzenie odstąpienia", bez opóźnienia. */
  var SCHOWEK = 'leze:odstapienie';

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-leze-withdrawal-form]');
    if (!form) return;

    function wartosc(nazwa) {
      var pole = form.querySelector('[name="contact[' + nazwa + ']"]');
      if (!pole) return '';
      if (pole.type === 'checkbox') return pole.checked ? pole.value : '';
      return pole.value || '';
    }

    var email = wartosc('email');
    if (!email) return;

    try {
      sessionStorage.setItem(SCHOWEK, JSON.stringify({
        email: email,
        tresc: wartosc('oswiadczenie'),
        zamowienie: wartosc('numer_zamowienia'),
        przedmiot: wartosc('przedmiot'),
        odbior: wartosc('data_odbioru'),
        zlozono: wartosc('zlozono')
      }));
    } catch (e) { /* tryb prywatny — trudno, zostaje mail do nas */ }
  });

  function potwierdzOdstapienie() {
    if (!document.querySelector('[data-leze-withdrawal-success]')) return;
    var surowe;
    try { surowe = sessionStorage.getItem(SCHOWEK); } catch (e) { return; }
    if (!surowe) return;
    try { sessionStorage.removeItem(SCHOWEK); } catch (e) { /* nieistotne */ }

    var dane;
    try { dane = JSON.parse(surowe); } catch (e) { return; }
    if (!dane || !dane.email) return;

    /* Data otrzymania to chwila, w której Shopify potwierdził przyjęcie
       formularza — czyli teraz. Datę złożenia niesie ukryte pole. */
    var teraz = new Date();
    var otrzymano = teraz.toLocaleDateString('pl-PL') + ', ' +
      teraz.toLocaleTimeString('pl-PL', { hour: '2-digit', minute: '2-digit' });

    identify(dane.email, {
      ODST_TRESC: dane.tresc,
      ODST_ZAMOWIENIE: dane.zamowienie,
      ODST_PRZEDMIOT: dane.przedmiot,
      ODST_ZLOZONO: dane.zlozono,
      ODST_OTRZYMANO: otrzymano
    });
    track('odstapienie_od_umowy', dane.email, {
      tresc: dane.tresc,
      zamowienie: dane.zamowienie,
      przedmiot: dane.przedmiot,
      data_odbioru: dane.odbior,
      zlozono: dane.zlozono,
      otrzymano: otrzymano
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', potwierdzOdstapienie);
  } else {
    potwierdzOdstapienie();
  }

  document.addEventListener('leze:quiz-complete', function (event) {
    window.lezeBrevoLastQuiz = event.detail || {};
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-leze-quiz-email-form] form');
    if (!form) return;
    var field = form.querySelector('input[type="email"]');
    if (!field || !field.value) return;

    var quiz = window.lezeBrevoLastQuiz || {};
    var attrs = {
      QUIZ_MODEL: quiz.title || '',
      QUIZ_MODEL_HANDLE: quiz.handle || '',
      QUIZ_ALT: quiz.altTitle || '',
      QUIZ_ALT_HANDLE: quiz.altHandle || '',
      QUIZ_URL: quiz.url || location.href
    };
    identify(field.value, attrs);
    track('ukonczyl_quiz', field.value, {
      model: attrs.QUIZ_MODEL,
      alternatywa: attrs.QUIZ_ALT,
      odpowiedzi: quiz.answers || {}
    });
    status(form, 'Wynik poleciał na maila.');
  });
})();
